const Menu = [
  {
    name: 'Thông báo',
    active: 'announcements',
    link: '/user/announcements',
    icon: 'vtd vtd-notification',
    subMenu: []
  },
  {
    name: 'Yêu cầu đã gửi',
    active: 'my-requests',
    link: '/user/my-requests',
    icon: 'vtd vtd-menu',
    subMenu: []
  },
  {
    name: 'Giỏ hàng',
    active: 'MyShoppingCartPage',
    link: '/user/my-shopping-cart',
    icon: 'vtd vtd-gio-hang',
    subMenu: []
  },
  {
    name: 'Lịch sử giao dịch',
    active: 'user-order-history',
    link: '/user/order-history',
    icon: 'vtd vtd-lich-su-giao-dich',
    subMenu: []
  },
  {
    name: 'Thông tin cá nhân',
    active: 'profile',
    link: '/profile',
    icon: 'vtd vtd-credit-card',
    subMenu: []
  }
];

export {Menu};



// WEBPACK FOOTER //
// ./components/layouts/user/menu/menu.js